import { FC, useEffect, useRef, useState } from 'react';
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
import './StatusButton.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

interface IProps {
    handleChange: (str: string) => void;
    id: string;
    isCreditMemo?: boolean;
    disable?: boolean;
}

const ButtonControl: FC<IProps> = ({
    handleChange,
    id,
    disable,
    isCreditMemo,
}) => {
    let ddRef: DropDownButtonComponent | any = useRef(null);
    const [Trimedid, SetTrimedId] = useState('');
    const [value, setValue] = useState('');
    const arInvoiceSavedata = useSelector(
        (store: RootState) => store.invoiceReducer.arInvoiceSaveData
    );
    const companyList = useSelector(
        (state: RootState) => state.sideBarReducer.companyList
    );
    const filterRules = (currentStatus: string) => {
        if (
            arInvoiceSavedata?.invoiceType === 'Hold' ||
            arInvoiceSavedata?.invoiceType === 'Donate'
        ) {
            switch (currentStatus) {
                case 'Draft':
                    return ['FinalClose', 'Cancelled'];
                default:
                    return;
            }
        } else {
            switch (currentStatus) {
                case 'Draft':
                    if (
                        arInvoiceSavedata?.invoiceNumber
                            ?.charAt(0)
                            .includes('C')
                    )
                        return [];
                    else return ['ReadyforSalvager', 'Cancelled'];
                // return ["Draft", "ReadyforSalvager", "Cancelled"];
                case 'ReadyforSalvager': {
                    const companyIds =
                        arInvoiceSavedata?.details?.map((detail: any) =>
                            Number(detail.companyId)
                        ) || [];
                    if (companyIds.length === 1) {
                        const companyDetail = companyList.find(
                            (company: any) => company.id === companyIds[0]
                        );

                        if (companyDetail?.excludeOutboundCost === true) {
                            return ['Draft', 'ManualApproved', 'Cancelled'];
                        }
                    }
                    return ['Draft', 'ReadyforExtract', 'Cancelled'];
                }
                case 'ReadyforExtract':
                    if (!arInvoiceSavedata?.extracted) return ['Cancelled'];
                    else return [];
                case 'PickupHold':
                    return ['PickupManualOverride'];
                default:
                    return;
            }
        }
    };

    const data = [
        {
            id: 'Draft',
            _id: 1,
            text: 'Draft',
        },
        {
            id: 'ReadyforSalvager',
            _id: 2,
            text: 'Ready for Salvager',
        },
        {
            id: 'ReadyforExtract',
            _id: 3,
            text: 'Ready for Extract',
        },
        {
            id: 'PickupAuto',
            _id: 4,
            text: 'Pickup, Auto Approved',
        },
        {
            id: 'PickupManualOverride',
            _id: 5,
            text: 'Pickup, Manual Override',
        },
        {
            id: 'PickupHold',
            _id: 6,
            text: 'Pickup, Hold',
        },
        {
            id: 'Picked',
            _id: 7,
            text: 'Picked',
        },
         {
            id: 'Cancelled',
            _id: 8,
            text: 'Cancelled',
        },

        {
            id: 'FinalClose',
            _id: 9,
            text: 'Final Close',
        },
       
        {
            id: 'ManualApproved',
            _id: 10,
            text: 'Manual Approved',
        },
    ];
    const creditMemoStatus = [
        {
            id: 'Draft',
            _id: 1,
            text: 'Draft',
        },
        {
            id: 'InProcess',
            _id: 2,
            text: 'In Process',
        },
        {
            id: 'Approved',
            _id: 3,
            text: 'Approved',
        },
        {
            id: 'Rejected',
            _id: 4,
            text: 'Rejected',
        },
        {
            id: 'Cancelled',
            _id: 5,
            text: 'Cancelled',
        },
    ];
    useEffect(() => {
        let tt: any = data.find((e) => e.text === id);
        if (tt) {
            let tid: string = tt?.id.replaceAll(' ', '');
            SetTrimedId(tid);
            setValue(tt.text);
        }
    }, [id]);

    const handleSelectedData = (e: any) => {
        handleChange(e.item);
    };

    const filterArInvoiceStatus = (data: any[]) => {
        const rules = filterRules(id.replaceAll(' ', '').replaceAll(',', ''));
        return data.filter((el) => rules?.includes(el.id));
    };

    const handleDropdown = (e: any) => {
        if (e.items.length === 0) {
            const elem = e.element.parentElement;
            elem.style.display = 'none';
        }
    };

    return (
        <div className="statusbutton">
            {Trimedid !== '' && (
                <DropDownButtonComponent
                    ref={(scope) => {
                        ddRef = scope;
                    }}
                    open={(e) => handleDropdown(e)}
                    id="status-button-dropdown"
                    className={`statusbutton_${Trimedid}`}
                    style={
                        disable
                            ? {
                                  opacity: 0.7,
                                  pointerEvents: 'none',
                                  cursor: 'default',
                              }
                            : {}
                    }
                    items={
                        disable
                            ? undefined
                            : isCreditMemo
                            ? creditMemoStatus
                            : filterArInvoiceStatus(data)
                    }
                    content={value}
                    select={handleSelectedData}
                ></DropDownButtonComponent>
            )}
            {/* <button className="side-btn"></button> */}
        </div>
    );
};

export default ButtonControl;
